import React, { useState } from 'react';
import currencyFormatter from '@magalu/stereo-ui-utils/currencyFormatter';
import { IncludeLabel, LabelContainer, IncludeDesktopLabel, IncludeDesktopContainer, IncludeDesktopHighlight } from './robbery-theft.styles';
import { include, includeDesktop, includeDesktopLabel, includeDesktopPrice, includeDesktopInstallments, includeInstallment } from './robbery-theft.data';
import { Checkbox } from '../../../atoms';

const Options = ({
  options,
  onChange,
  desktopMode,
  installmentQuantity
}) => {
  const [checkedItems, setCheckedItem] = useState(new Map());

  const handleChange = (e, item) => {
    var _checkedItems$get, _checkedItems$get2;

    onChange(item, ((_checkedItems$get = checkedItems.get(item == null ? void 0 : item.description)) == null ? void 0 : _checkedItems$get.checked) || false);
    const {
      name,
      checked
    } = e.target;

    if ((_checkedItems$get2 = checkedItems.get(item == null ? void 0 : item.description)) != null && _checkedItems$get2.checked) {
      setCheckedItem(prevState => {
        prevState.delete(item == null ? void 0 : item.description);
        return new Map(prevState);
      });
    } else {
      setCheckedItem(prevState => {
        return new Map(prevState).set(name, {
          checked,
          item
        });
      });
    }
  };

  return options.map(item => {
    var _checkedItems$get3;

    return /*#__PURE__*/React.createElement(LabelContainer, {
      key: item == null ? void 0 : item.id,
      p: '12px 0'
    }, /*#__PURE__*/React.createElement(Checkbox, {
      onChange: e => handleChange(e, item),
      name: item == null ? void 0 : item.description,
      checked: ((_checkedItems$get3 = checkedItems.get(item == null ? void 0 : item.description)) == null ? void 0 : _checkedItems$get3.checked) || false
    }, desktopMode ? /*#__PURE__*/React.createElement(IncludeDesktopContainer, null, /*#__PURE__*/React.createElement(IncludeDesktopLabel, null, includeDesktop[0], /*#__PURE__*/React.createElement("br", null), includeDesktop[1]), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(IncludeLabel, null, includeDesktopLabel, ' ', /*#__PURE__*/React.createElement(IncludeDesktopHighlight, null, includeDesktopInstallments(installmentQuantity, currencyFormatter({
      value: (item == null ? void 0 : item.price) / installmentQuantity
    }))), includeDesktopPrice(currencyFormatter({
      value: item == null ? void 0 : item.price
    })))) : /*#__PURE__*/React.createElement(IncludeLabel, null, include, ' ', /*#__PURE__*/React.createElement("b", {
      "data-testid": "option-price"
    }, currencyFormatter({
      value: item == null ? void 0 : item.price
    })), ' ', /*#__PURE__*/React.createElement("span", {
      "data-testid": "installment-quantity"
    }, includeInstallment(installmentQuantity, currencyFormatter({
      value: (item == null ? void 0 : item.price) / installmentQuantity
    })))), /*#__PURE__*/React.createElement("br", null)));
  });
};

Options.defaultProps = {
  options: [],
  onChange: () => ({}),
  desktopMode: false,
  installmentQuantity: null
};
export default Options;